import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ['badge', 'checkbox']

  connect() {
    let counter = 0

    this.checkboxTargets.forEach(checkbox => {
      if (checkbox.checked) ++counter
    });

    if (counter > 0) {
      this.badgeTarget.classList.remove('hidden')
      this.badgeTarget.innerText = counter
    }
  }

  disconnect() {
    this.badgeTarget.classList.add('hidden')
  }
}
